import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const RaindropIcon = (props: Props) => (
  <Svg viewBox='0 0 41 40' fill='none' {...props}>
    <Path
      d='M20.4998 3.33325C11.6165 10.9166 7.1665 17.4666 7.1665 22.9999C7.1665 31.2999 13.4998 36.6666 20.4998 36.6666C27.4998 36.6666 33.8332 31.2999 33.8332 22.9999C33.8332 17.4666 29.3832 10.9166 20.4998 3.33325ZM20.4998 33.3333C14.9165 33.3333 10.4998 29.0499 10.4998 22.9999C10.4998 19.0999 13.7498 13.9333 20.4998 7.76659C27.2498 13.9333 30.4998 19.0833 30.4998 22.9999C30.4998 29.0499 26.0832 33.3333 20.4998 33.3333ZM13.5498 23.3333C14.1665 23.3333 14.6665 23.7666 14.7832 24.3666C15.4665 28.0666 18.5832 29.3333 20.8498 29.1499C21.5665 29.1166 22.1665 29.6833 22.1665 30.3999C22.1665 31.0666 21.6332 31.6166 20.9665 31.6499C17.4165 31.8666 13.2665 29.8333 12.3165 24.7833C12.1832 24.0333 12.7832 23.3333 13.5498 23.3333Z'
      fill='#FE5000'
    />
  </Svg>
)
